module.exports = __webpack_public_path__ + "img/desc_illust_sp.9940cc5c.png";